import { Text, Grid } from '@simplywallst/ui-core';

export const EmptyState = () => (
  <Grid placeContent="center" gap="4px">
    <Text typography="xSmall" color="white" textAlign="center">
      No data currently available
    </Text>
    <Text typography="tiny" color="whiteRGBA" opacity={0.5} textAlign="center">
      Please try again later
    </Text>
  </Grid>
);
